/**
 * Created by Ivan on 28.09.2025
 */

const RaveReviewsStartWindow = CleverappsWindow.extend({
    onWindowLoaded: function (addReviewsCallback) {
        this.addReviewsCallback = addReviewsCallback;
        this._super({
            name: "RaveReviewsStartWindow",
            content: this.createContent(),
            noBackground: true
        });
    },

    createContent: function () {
        const styles = cleverapps.styles.RaveReviewsStartWindow;

        const content = this.content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize2(styles);

        const rupor = this.rupor = new cleverapps.Spine(bundles.rave_reviews_start.jsons.rupor_light);
        content.addChild(rupor);
        rupor.setAlignment(styles.rupor);

        const text = this.text = cleverapps.UI.generateOnlyText(Messages.get("RaveReviewsStartWindow.Text"), cleverapps.styles.FONTS.RAVE_REVIEWS_START_TEXT);
        content.addChild(text);
        text.setAlignment(styles.text);

        return content;
    },

    onShow: function () {
        this.rupor.setAnimation(0, "animation", false);
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.6),
            new cc.CallFunc(() => {
                this.addReviewsCallback();
            }),
            new cc.DelayTime(1.8),
            new cc.CallFunc(this.close.bind(this))
        ));

        this.text.runAction(new cc.Sequence(
            new cc.DelayTime(1),
            new cc.FadeOut(0.35)
        ));

        cleverapps.effects.fire("rave_reviews.rupor.show");
    },

    listBundles: function () {
        return ["rave_reviews_start"];
    }
});

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    RAVE_REVIEW_START_COLOR: new cc.Color(251, 224, 16, 255)
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    RAVE_REVIEWS_START_TEXT: {
        size: 60,
        color: cleverapps.styles.COLORS.RAVE_REVIEW_START_COLOR,
        stroke: cleverapps.styles.DECORATORS.RED_STROKE
    }
});

cleverapps.styles.RaveReviewsStartWindow = {
    width: 765,
    height: 1015,

    rupor: {
        x: { align: "center" },
        y: { align: "center" }
    },

    text: {
        x: { align: "center" },
        y: { align: "center", dy: 250 }
    }
};
